<script setup lang="ts">
const accountStore = useAccountStore();
</script>

<template>
  <div class="shout-out-box">
    <h4>{{ $t('shout_out.multi_portal.title') }}</h4>
    <p>{{ $t('shout_out.multi_portal.text_start') }}</p>
    <img src="assets/images/multi-portal/multiportal-transparent-1.png" alt="Bild zeigt Export zu anderen Listingportalen" class="multiportal-partner" />
    <tw-shout-outs-multi-portal-modal v-if="accountStore.housing" :housing="accountStore.housing">
      <template #trigger="{ toggle }">
        <tw-ui-button class="action-button" @click="toggle">{{ $t('shout_out.multi_portal.text_button') }}</tw-ui-button>
      </template>
    </tw-shout-outs-multi-portal-modal>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tw-variables.scss';
@import '~/assets/styles/tw-form.scss';
@import '@/assets/styles/tw-mixins.scss';

.shout-out-box {
  @include shout-out;
}
.shout-out-box {
  padding: 1rem;
}
.partner {
  padding: 0.5rem;
  border-radius: 0.25rem;
}
.action-button {
  @include tw-button-submit;
  padding: 0.5rem 4rem;
  margin-bottom: 1rem;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  text-transform: uppercase;
  font-family: 'Sofia W01', sans-serif;
}

.multiportal-partner {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 280px;
  margin: 0 auto; // Zentriert das Bild im Container
  padding: 0 0 1rem 0;
  display: block; // Sicherstellen, dass es block-basiert ist
}
</style>
